import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const TOOLS = [
  { to: "/calcul-mensualite-credit", label: "Mensualité crédit" },
  { to: "/calcul-capacite-emprunt", label: "Capacité d’emprunt" },
  { to: "/estimation-frais-notaire", label: "Frais de notaire" },
  { to: "/calcul-rentabilite-locative", label: "Rentabilité locative" },
  { to: "/calcul-plus-value-immobiliere", label: "Plus-value" },
  {
    to: "/generateur-attestation-hebergement",
    label: "Attestation hébergement",
  },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [toolsOpen, setToolsOpen] = useState(false);
  const location = useLocation();
  const toolsRef = useRef(null);

  // ferme menus quand on change de page
  useEffect(() => {
    setMobileOpen(false);
    setToolsOpen(false);
  }, [location.pathname]);

  // ferme dropdown outils si clic extérieur
  useEffect(() => {
    const handler = (e) => {
      if (toolsRef.current && !toolsRef.current.contains(e.target)) {
        setToolsOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <header className="navGlass" style={styles.header}>
      <div style={styles.container}>
        {/* LOGO / BRAND */}
        <Link to="/" style={styles.brand}>
          <div style={styles.logo}>AT</div>
          <div>
            <div style={styles.brandTitle}>Outils Immobilier</div>
            <div style={styles.brandSub}>simulateurs & PDF</div>
          </div>
        </Link>

        {/* DESKTOP */}
        <nav className="nav-desktop" style={styles.nav}>
          <NavLink to="/" end style={navLink}>
            Accueil
          </NavLink>

          <div ref={toolsRef} style={{ position: "relative" }}>
            <button
              onClick={() => setToolsOpen((v) => !v)}
              style={{
                ...styles.navBtn,
                ...(toolsOpen ? styles.navBtnActive : {}),
              }}
            >
              Outils{" "}
              <span style={{ opacity: 0.6 }}>{toolsOpen ? "▲" : "▼"}</span>
            </button>

            {toolsOpen && (
              <div style={styles.dropdown}>
                {TOOLS.map((t) => (
                  <NavLink key={t.to} to={t.to} style={dropdownLink}>
                    {t.label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>

          <NavLink to="/contact" style={navLink}>
            Contact
          </NavLink>
        </nav>

        {/* BURGER */}
        <button
          className="nav-burger"
          onClick={() => setMobileOpen((v) => !v)}
          style={styles.burger}
          aria-label="Menu"
        >
          <span style={burgerLine} />
          <span style={burgerLine} />
          <span style={burgerLine} />
        </button>
      </div>

      {/* MOBILE MENU */}
      {mobileOpen && (
        <div style={styles.mobilePanel}>
          <NavLink to="/" end style={mobileLink}>
            Accueil
          </NavLink>

          <div style={styles.mobileBox}>
            <div style={styles.mobileTitle}>Outils</div>
            {TOOLS.map((t) => (
              <NavLink key={t.to} to={t.to} style={mobileSubLink}>
                {t.label}
              </NavLink>
            ))}
          </div>

          <NavLink to="/contact" style={mobileLink}>
            Contact
          </NavLink>
        </div>
      )}

      {/* RESPONSIVE */}
      <style>{`
        @media (max-width: 900px) {
          .nav-desktop { display: none !important; }
          .nav-burger { display: flex !important; }
        }
        @media (min-width: 901px) {
          .nav-burger { display: none !important; }
        }
      `}</style>
    </header>
  );
}

/* ===== Styles ===== */

const styles = {
  header: {
    position: "sticky",
    top: 0,
    zIndex: 50,
  },
  container: {
    maxWidth: 1100,
    margin: "0 auto",
    padding: "14px 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  brand: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    textDecoration: "none",
    color: "inherit",
  },
  logo: {
    width: 42,
    height: 42,
    borderRadius: 14,
    border: "1px solid rgba(255,255,255,.2)",
    display: "grid",
    placeItems: "center",
    fontWeight: 900,
  },
  brandTitle: {
    fontWeight: 900,
    letterSpacing: ".3px",
  },
  brandSub: {
    fontSize: 12,
    opacity: 0.7,
  },
  nav: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  navBtn: {
    padding: "8px 14px",
    borderRadius: 999,
    border: "1px solid rgba(255,255,255,.2)",
    background: "rgba(255,255,255,.08)",
    color: "inherit",
    cursor: "pointer",
    fontWeight: 700,
  },
  navBtnActive: {
    background: "rgba(255,255,255,.18)",
  },
  dropdown: {
    position: "absolute",
    top: 46,
    right: 0,
    width: 280,
    background: "rgba(20,26,40,.95)",
    backdropFilter: "blur(12px)",
    border: "1px solid rgba(255,255,255,.15)",
    borderRadius: 16,
    padding: 8,
    boxShadow: "0 20px 60px rgba(0,0,0,.4)",
  },
  burger: {
    width: 44,
    height: 44,
    borderRadius: 14,
    border: "1px solid rgba(255,255,255,.2)",
    background: "rgba(255,255,255,.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: 4,
    cursor: "pointer",
  },
  mobilePanel: {
    padding: 16,
    display: "grid",
    gap: 12,
    borderTop: "1px solid rgba(255,255,255,.1)",
  },
  mobileBox: {
    border: "1px solid rgba(255,255,255,.12)",
    borderRadius: 16,
    padding: 12,
  },
  mobileTitle: {
    fontWeight: 800,
    marginBottom: 8,
  },
};

const navLink = ({ isActive }) => ({
  padding: "8px 14px",
  borderRadius: 999,
  border: "1px solid rgba(255,255,255,.2)",
  background: isActive ? "rgba(255,255,255,.18)" : "rgba(255,255,255,.08)",
  textDecoration: "none",
  color: "inherit",
  fontWeight: 700,
});

const dropdownLink = ({ isActive }) => ({
  display: "block",
  padding: "10px 12px",
  borderRadius: 12,
  textDecoration: "none",
  color: "inherit",
  fontWeight: 650,
  background: isActive ? "rgba(255,255,255,.15)" : "transparent",
});

const mobileLink = ({ isActive }) => ({
  ...navLink({ isActive }),
  display: "block",
});

const mobileSubLink = ({ isActive }) => ({
  display: "block",
  padding: "10px 12px",
  borderRadius: 12,
  textDecoration: "none",
  color: "inherit",
  fontWeight: 650,
  background: isActive ? "rgba(255,255,255,.15)" : "transparent",
});

const burgerLine = {
  width: 18,
  height: 2,
  background: "white",
  borderRadius: 2,
};
